import * as React from 'react';
import { useState } from 'react';
import { Modal, notification, Typography } from 'antd';
import axiosApiInstance from '../../../api/axiosClient';

type Props = {
    creatorId: number;
};

const RefreshCreator = (props: Props) => {
    const [loading, setLoading] = useState(false);

    const handleClick = async () => {
        // Get the creator's name for the confirmation message
        let creatorName = 'this creator';
        try {
            const { data } = await axiosApiInstance.get(`/api/creators/items/${props.creatorId}`);
            creatorName = data?.creator ?? creatorName;
        } catch (e) {
            console.error('could not load creator name', e);
        }

        Modal.confirm({
            title: `Are you sure you want to fetch "${creatorName}" details?`,
            okText: 'Yes, fetch',
            cancelText: 'Cancel',
            onOk: async () => {
                setLoading(true);
                try {
                    await axiosApiInstance.post(`/api/creators/items/${props.creatorId}/refresh`);
                    notification.success({
                        message: 'Refresh started',
                        description: 'The creator details are being fetched. They will update shortly.',
                    });
                } catch (error: any) {
                    notification.error({
                        message: 'Error',
                        description: error?.response?.data?.error ?? 'Failed to refresh creator details.',
                    });
                } finally {
                    setLoading(false);
                }
            },
        });
    };

    return (
        <Typography.Link onClick={handleClick} disabled={loading}>
            Refresh
        </Typography.Link>
    );
};

export default RefreshCreator;